export default {
  OAuth: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "oauth"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/OAuth.js
// module id = H9Tu
// module chunks = 16